// see https://css-tricks.com/snippets/javascript/get-url-variables/
module.exports.getQueryParamValue = (paramName) => {

    const parsedUrl = new URL(window.location.href);
    return parsedUrl.searchParams.get(paramName);

};
